import React, { FC, HTMLAttributes, ReactNode } from 'react'
import cn from 'classnames'
import { RouteCheckboxWhite } from '@/root/ui/shared/icons/RouteCheckboxWhite'

interface CheckboxProps extends HTMLAttributes<HTMLInputElement> {
  checked: boolean
  label?: ReactNode
  disabled?: boolean
  variant?: 'error' | 'success'
  colorLabel?: boolean
  testId?: string
}

export const Checkbox: FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  variant = 'error',
  className,
  colorLabel = false,
  testId,
}) => {
  return (
    <label
      className={cn(
        {
          'text-error': checked && variant === 'error' && colorLabel,
          'cursor-not-allowed': disabled,
          'cursor-pointer': !disabled,
        },
        'flex gap-2',
        className
      )}
    >
      <input
        type="checkbox"
        data-testid={testId}
        disabled={disabled}
        checked={checked}
        className="absolute appearance-none opacity-0"
        onChange={onChange}
      />
      <div
        className={cn('flex h-5 w-5 min-w-5 items-center justify-center rounded-sm border-2 transition duration-300', {
          'bg-error': checked && variant === 'error',
          'bg-base-medium-light': checked && variant === 'success',
          'border-neutral-normal-light bg-neutral-normal-light cursor-not-allowed': disabled,
          'border-error cursor-pointer': !disabled && variant === 'error',
          'border-primary-base cursor-pointer': !disabled && variant === 'success',
        })}
      >
        <RouteCheckboxWhite className={cn({ hidden: !checked })} />
      </div>
      <p className={cn({ 'text-neutral-medium-light': disabled })}>{label}</p>
    </label>
  )
}
